
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/society/signup/success",
      function () {
        return require("private-next-pages/society/signup/success/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/society/signup/success"])
      });
    }
  